import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportPassenger extends Schema {
    @type("number")
    @defaultValue(0)
    stage: number;
    @type("number")
    @defaultValue(0)
    state: number;
    @type("number")
    @defaultValue(-1)
    slot: number;
    @type("number")
    @defaultValue(0)
    remaining: number;
    @type("number")
    @defaultValue(0)
    serial: number;
    @type("number")
    @defaultValue(0)
    queuedAt: number;
    @type("number")
    @defaultValue(0)
    tint: number;
    @type("boolean")
    @defaultValue(false)
    vip: boolean;
    @type("boolean")
    @defaultValue(false)
    paid: boolean;
    @type("number")
    @defaultValue(-1)
    vending: number;
    @type("number")
    @defaultValue(0)
    shopFrames: number;
    @type("number")
    @defaultValue(0)
    gate: number;
    @type("number")
    @defaultValue(-1)
    seat: number;
    @type("boolean")
    @defaultValue(false)
    seated: boolean;
    @type("number")
    @defaultValue(0)
    walkStep: number;
    @type("number")
    @defaultValue(0)
    releaseFrame: number;
    @type("boolean")
    @defaultValue(false)
    inquired: boolean;
    /** Just landed: walks out through the landside exit instead of the service route. */
    @type("boolean")
    @defaultValue(false)
    arriving: boolean;
    @type("boolean")
    @defaultValue(false)
    entering: boolean;
    /** Bought a snack at vending; drops its wrapper near Security. */
    @type("boolean")
    @defaultValue(false)
    snack: boolean;
    @type("number")
    @defaultValue(-1)
    queueOrder: number;
    @type("number")
    @defaultValue(80)
    happiness: number;
    /** Queue patience in frames; drains while waiting, faster near litter. */
    @type("number")
    @defaultValue(1800)
    patience: number;
    /** Legacy walkout countdown; routing clears it and keeps the passenger. */
    @type("number")
    @defaultValue(0)
    leaving: number;
    /** Standing near litter; drains patience faster and shows the sad bubble. */
    @type("boolean")
    @defaultValue(false)
    sad: boolean;
}
